import persistedState from "vuex-persistedstate";
import { createStore } from "vuex";
import { localStorage } from "../utils/LocalStorage";
import userInfo from "./modules/userInfo";
import appInfo from "./modules/appInfo";
export default createStore({
  modules: {
    userInfo,
    appInfo,
  },
  plugins: [
    persistedState({
      storage: window.sessionStorage,
      paths: ["userInfo"], // 需要做持久化的vuex模块
      getState: (key) => localStorage.get(key),
      setState: (key, state) => localStorage.set(key, state),
    }),
  ],
});
